import React, { useContext, useEffect, useState } from 'react'
import Select from '../components/Select'
import { useAuth } from '@clerk/clerk-react'
import { USER_CONTEXT } from '../context/ContextProvider'
import { useNavigate } from 'react-router-dom'

const JoinGroup = () => {
  const navigate = useNavigate();
  let { data,setData } = useContext(USER_CONTEXT)
  let [selectedGroup, setSelectedGroup] = useState(0)

  return (
    <div className="w-full min-h-[500px] justify-center flex flex-col items-center text-white">
      <div className="max-w-xl w-full py-3 px-5 flex flex-col items-stretch gap-y-5">
        <div>
          <h2 className="text-3xl font-medium text-center">Join Group</h2>
          <p className="text-gray-400 text-center">
            Join any group to manage tasks
          </p>
        </div>
        <Select
          label="Groups"
          values={data.groups}
          selected={selectedGroup}
          setSelected={setSelectedGroup}
        />
        <button
          onClick={() => {
            setData({
              type: 'SELECT_GROUP',
              payload: {
                group: data.groups[selectedGroup],
              },
            })
            navigate("/")
            
          }}
          className="bg-[#050505] w-full rounded-lg py-2.5 px-3 text-white text-center hover:invert transition-all duration-300"
        >
          Join Group
        </button>
      </div>
    </div>
  )
}

export default JoinGroup
